import bindAll from 'lodash.bindall';
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import AuthModalComponent from '../components/auth-modal/auth-modal.jsx';
import authApi from '../lib/auth-api.js';
import {setSession, clearSession} from '../reducers/session.js';
import {selectLocale} from '../reducers/locales.js';

class AuthModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleSubmit',
            'handleSwitchMode',
            'handleUsernameChange',
            'handleEmailChange',
            'handlePasswordChange',
            'handleDisplayNameChange'
        ]);
        const initialMode = props.initialMode || 'login';
        this.state = {
            isLogin: initialMode === 'login',
            isLoading: false,
            error: null,
            pendingApproval: false,
            username: '',
            email: '',
            password: '',
            displayName: ''
        };
    }

    handleUsernameChange (e) {
        this.setState({username: e.target.value});
    }
    handleEmailChange (e) {
        this.setState({email: e.target.value});
    }
    handlePasswordChange (e) {
        this.setState({password: e.target.value});
    }
    handleDisplayNameChange (e) {
        this.setState({displayName: e.target.value});
    }

    handleSwitchMode () {
        this.setState(prev => ({
            isLogin: !prev.isLogin,
            error: null,
            pendingApproval: false
        }));
    }

    async handleSubmit (e) {
        e.preventDefault();
        this.setState({isLoading: true, error: null});

        try {
            let user;
            if (this.state.isLogin) {
                user = await authApi.login({
                    username: this.state.username,
                    password: this.state.password
                });
            } else {
                const result = await authApi.register({
                    username: this.state.username,
                    email: this.state.email,
                    password: this.state.password,
                    displayName: this.state.displayName || this.state.username
                });

                // Account requires admin approval
                if (result.pending) {
                    this.setState({pendingApproval: true, isLoading: false});
                    return;
                }
                user = result;
            }

            this.props.onSetSession(user);

            // After login: apply user's saved locale from backend
            // After register: save current locale to backend as the user's preference
            if (this.state.isLogin && user.locale) {
                this.props.onSelectLocale(user.locale);
                document.documentElement.lang = user.locale;
                try {
                    localStorage.setItem('scratch_locale', user.locale);
                } catch (_) { /* private browsing */ }
            } else if (!this.state.isLogin) {
                // New registration — persist the current frontend locale to backend
                const currentLocale = this.props.currentLocale;
                if (currentLocale) {
                    authApi.updateLocale(currentLocale).catch(() => {});
                }
            }

            // In gated mode, notify parent of successful login
            if (this.props.onLoginSuccess) {
                this.props.onLoginSuccess(user);
            } else {
                this.props.onClose();
            }
        } catch (err) {
            this.setState({error: err.message});
        } finally {
            this.setState({isLoading: false});
        }
    }

    render () {
        return (
            <AuthModalComponent
                displayName={this.state.displayName}
                email={this.state.email}
                error={this.state.error}
                gated={this.props.gated}
                isLoading={this.state.isLoading}
                isLogin={this.state.isLogin}
                password={this.state.password}
                pendingApproval={this.state.pendingApproval}
                username={this.state.username}
                onClose={this.props.onClose}
                onDisplayNameChange={this.handleDisplayNameChange}
                onEmailChange={this.handleEmailChange}
                onPasswordChange={this.handlePasswordChange}
                onPendingBack={() => this.setState({
                    pendingApproval: false,
                    isLogin: true,
                    error: null
                })}
                onSubmit={this.handleSubmit}
                onSwitchMode={this.handleSwitchMode}
                onUsernameChange={this.handleUsernameChange}
            />
        );
    }
}

AuthModal.propTypes = {
    currentLocale: PropTypes.string,
    gated: PropTypes.bool,
    initialMode: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onLoginSuccess: PropTypes.func,
    onSelectLocale: PropTypes.func.isRequired,
    onSetSession: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    currentLocale: state.locales.locale
});

const mapDispatchToProps = dispatch => ({
    onSetSession: user => dispatch(setSession(user)),
    onSelectLocale: locale => dispatch(selectLocale(locale))
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthModal);
